export default "__VITE_ASSET__RBE3ttMU__"